/* ==========================================================================
   Zapatos Obi — theme.js
   Núcleo del tema: pub/sub de eventos y utilidades compartidas.
   Los módulos (cart, búsqueda, producto) lo consumen vía window.Obi.
   ========================================================================== */
(function () {
  'use strict';

  window.Obi = window.Obi || {};

  /* ---------- Rutas de Shopify (con prefijo de idioma/mercado) ---------- */
  Obi.routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Nombres de eventos ---------- */
  Obi.events = {
    cartUpdated: 'cart:updated',
    cartError: 'cart:error',
    drawerOpen: 'drawer:open',
    drawerClose: 'drawer:close',
  };

  /* ---------- Pub/Sub ---------- */
  var subscribers = {};

  Obi.on = function (event, callback) {
    (subscribers[event] = subscribers[event] || []).push(callback);
    return function () {
      Obi.off(event, callback);
    };
  };

  Obi.off = function (event, callback) {
    if (!subscribers[event]) return;
    subscribers[event] = subscribers[event].filter(function (cb) {
      return cb !== callback;
    });
  };

  Obi.emit = function (event, detail) {
    (subscribers[event] || []).forEach(function (cb) {
      cb(detail);
    });
  };

  /* ---------- Helpers fetch ---------- */
  Obi.fetchJSON = function (url, options) {
    options = options || {};
    var headers = Object.assign(
      { 'Content-Type': 'application/json', Accept: 'application/json' },
      options.headers || {}
    );
    return fetch(url, Object.assign({}, options, { headers: headers })).then(function (res) {
      return res.json();
    });
  };

  /* Obtiene el HTML de una o varias secciones vía Section Rendering API. */
  Obi.getSectionHTML = function (sectionId, params) {
    var url = Obi.routes + '?section_id=' + encodeURIComponent(sectionId);
    if (params) url += '&' + params;
    return fetch(url).then(function (res) {
      return res.text();
    });
  };

  /* ---------- Carrusel con flechas en las cards de producto ---------- */
  function showCardImage(media, idx) {
    var alts = media.querySelectorAll('.product-card__img--alt');
    var total = alts.length + 1; /* + imagen principal */
    idx = ((idx % total) + total) % total;
    media.setAttribute('data-idx', idx);
    for (var i = 0; i < alts.length; i++) {
      alts[i].classList.toggle('is-visible', i === idx - 1);
    }
    /* bolitas indicadoras */
    var card = media.closest('.product-card');
    if (card) {
      var dots = card.querySelectorAll('.product-card__dot');
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === idx);
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-prev], [data-card-next]');
    if (!btn) return;
    e.preventDefault();
    var media = btn.closest('.product-card__media');
    if (!media) return;
    var current = parseInt(media.getAttribute('data-idx'), 10) || 0;
    var delta = btn.hasAttribute('data-card-prev') ? -1 : 1;
    showCardImage(media, current + delta);
  });

  /* Deslizar con el dedo (táctil) para cambiar de foto */
  var touchMedia = null;
  var touchX = null;
  var touchY = null;

  document.addEventListener(
    'touchstart',
    function (e) {
      var media = e.target.closest('.product-card__media');
      if (!media) return;
      touchMedia = media;
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!touchMedia || touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      /* swipe horizontal claro (no scroll vertical) */
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        var current = parseInt(touchMedia.getAttribute('data-idx'), 10) || 0;
        showCardImage(touchMedia, current + (dx < 0 ? 1 : -1));
      }
      touchMedia = null;
      touchX = null;
      touchY = null;
    },
    { passive: true }
  );

  /* ---------- Utilidad: debounce ---------- */
  Obi.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait || 250);
    };
  };
})();
